import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PlaylistInfo} from '../model/playlist-info';
import {Observable} from 'rxjs/Observable';
import {Id} from '../model/id';
import {PlaylistTrack, TrackPosition} from '../model/track';

@Injectable()
export class PlaylistService {

  constructor(private httpClient : HttpClient) { }

  get(id : string) : Observable<PlaylistInfo> {
    return this.httpClient.get<PlaylistInfo>("api/playlist/" + id);
  }

  create(name : string, isPublic: boolean) : Observable<Id> {
    let hp = new HttpParams().set("name", name).set("is_public", isPublic + "");
    return this.httpClient.post<Id>("api/playlist", null, {params  : hp});
  }

  update(id : string, name : string, isPublic: boolean) : Observable<any> {
    let hp = new HttpParams().set("name", name)
      .set("is_public", isPublic + "");
    return this.httpClient.put("api/playlist/" + id, null,{params  : hp});
  }

  delete(id: string) : Observable<any> {
    return this.httpClient.delete("api/playlist/" + id);
  }

  list() : Observable<PlaylistInfo[]> {
    return this.httpClient.get<PlaylistInfo[]>("api/playlist");
  }

  tracks(id : string) : Observable<PlaylistTrack[]> {
    return this.httpClient.get<PlaylistTrack[]>("api/playlist/" + id + "/track");
  }

  addTrack(playlistId: string, trackId: string) : Observable<TrackPosition> {
    return this.httpClient.put<TrackPosition>("api/playlist/" + playlistId + "/track/" + trackId, null);
  }

  removeTrack(playlistId : string, trackId: string) : Observable<any> {
    return this.httpClient.delete("api/playlist/" + playlistId + "/track/" + trackId);
  }

  moveTrack(playlistId: string, current : string, onPlaceOf :  string) : Observable<any> {
    let hp = new HttpParams().set("on_place_of", onPlaceOf);
    return this.httpClient.post("api/playlist/" + playlistId + "/track/" + current, null, {params:hp} );
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/playlist.service.ts